const zh = {
  site: {
    name: "屁屁影院",
    subtitle: "电影大全免费在线观看",
    description: "屁屁影院作为知名免费影视站，汇聚电影大全，高清免费在线观看不缓冲，最新大片即点即播，热门经典应有尽有，秒速播放，极速加载，追剧观影更畅快。"
  },
  nav: {
    home: "首页",
    category: "分类",
    about: "关于我们",
    search: "搜索电影...",
    watchNow: "立即观看"
  },
  home: {
    heroTitle: "最新高清大片",
    heroSubtitle: "即点即播 · 不缓冲",
    heroDesc: "汇聚海量电影资源，最新大片第一时间更新，高清画质流畅播放，让您随时随地享受极致观影体验",
    hotRecommend: "热门推荐",
    newArrival: "最新上架",
    categoryEntry: "分类浏览",
    viewAll: "查看全部",
    features: {
      title: "为什么选择屁屁影院？",
      subtitle: "我们致力于为用户提供极致的免费观影体验",
      items: [
        { title: "海量片源", desc: "50000+部电影资源，涵盖动作、喜剧、科幻、爱情等各类题材，满足不同观影需求", icon: "ri-database-2-line" },
        { title: "高清画质", desc: "1080P超清画质，智能码率调节技术，在保证画质的同时实现流畅播放", icon: "ri-4k-line" },
        { title: "秒速加载", desc: "全球CDN加速节点覆盖，智能线路优化，确保即点即播，告别漫长等待", icon: "ri-flashlight-line" },
        { title: "完全免费", desc: "无需注册、无需付费，所有电影资源免费开放，轻松享受观影乐趣", icon: "ri-vip-crown-line" }
      ]
    }
  },
  category: {
    title: "电影分类",
    all: "全部",
    noMovies: "该分类暂无电影",
    movieCount: "部电影"
  },
  movie: {
    director: "导演",
    cast: "主演",
    year: "年份",
    region: "地区",
    duration: "时长",
    rating: "评分",
    category: "类型",
    description: "剧情简介",
    relatedMovies: "相关推荐",
    breadcrumbHome: "首页",
    breadcrumbCategory: "分类",
    views: "次播放"
  },
  about: {
    title: "关于屁屁影院",
    brandIntro: "品牌介绍",
    brandDesc: "屁屁影院创立于2020年，是一家专注于提供免费高清影视在线观看服务的平台。我们始终坚持\"免费、高清、流畅\"的产品理念，致力于为全球华语用户打造极致的观影体验。\n\n经过多年的发展，屁屁影院已积累了超过50000部电影资源，涵盖动作、喜剧、科幻、爱情、悬疑、动画等多种类型，满足了不同用户的观影需求。我们拥有一支专业的技术团队，通过先进的CDN加速技术和智能码率调节算法，确保每一位用户都能享受到流畅、清晰的观影体验。\n\n未来，屁屁影院将继续秉持初心，不断扩充片源库，优化播放技术，让更多人能够轻松享受电影的乐趣。",
    statsTitle: "数据一览",
    testimonialsTitle: "用户口碑",
    faqTitle: "常见问题",
    contactTitle: "联系我们",
    contactDesc: "如有任何问题或建议，欢迎通过以下方式联系我们",
    email: "电子邮箱",
    emailValue: "contact@pipicinema.com",
    wechat: "微信公众号",
    wechatValue: "屁屁影院",
    weibo: "官方微博",
    weiboValue: "@屁屁影院官方",
    address: "公司地址",
    addressValue: "北京市朝阳区建国路88号SOHO现代城A座"
  },
  footer: {
    copyright: "© 2026 屁屁影院 版权所有",
    links: "友情链接",
    privacy: "隐私政策",
    terms: "使用条款",
    disclaimer: "免责声明：本站所有视频资源均来自互联网收集，仅供网友学习交流，不提供影视资源存储和上传服务。如侵犯了您的权益，请联系我们删除。"
  },
  search: {
    placeholder: "搜索你想看的电影...",
    noResult: "未找到相关电影"
  }
};

export default zh;